<div class="payments-tab">
  <h2 class="title">{{ "riepilogo.payments.title" | translate }}</h2>
  <p class="tab-desc">{{ "riepilogo.payments.title_desc" | translate }}</p>

  <!-- HERO: totale + progresso -->
  <div class="pay-hero" [class.saldato]="isSaldato">
    <p class="pay-hero-label">{{ "riepilogo.payments.total" | translate }}</p>
    <p class="pay-hero-total">€ {{ totalAll | number: "1.2-2" }}</p>

    <div class="pay-progress" [attr.aria-label]="incassatoPct + '%'">
      <div class="pay-progress-fill" [style.width.%]="incassatoPct"></div>
    </div>

    <div class="pay-hero-sub">
      <span class="pay-hero-collected">
        {{ "riepilogo.payments.collected" | translate }}
        <strong>€ {{ incassato | number: "1.2-2" }}</strong>
      </span>
      <span class="pay-hero-remaining">
        {{ "riepilogo.payments.to_collect" | translate }}
        <strong>€ {{ daIncassare | number: "1.2-2" }}</strong>
      </span>
    </div>

    <p class="pay-overdue" *ngIf="balanceOverdue">
      {{ "riepilogo.payments.overdue" | translate: { date: (balance.due_date | date: "dd/MM/yyyy") } }}
    </p>
  </div>

  <!-- Breakdown costi -->
  <div class="pay-breakdown" *ngIf="totalServices > 0 || testCost > 0 || travelFee > 0">
    <span class="pay-break-item" *ngIf="totalServices > 0">
      {{ "riepilogo.payments.services" | translate }} € {{ totalServices | number: "1.2-2" }}
    </span>
    <span class="pay-break-item" *ngIf="testCost > 0">
      {{ "riepilogo.trial_cost" | translate }} € {{ testCost | number: "1.2-2" }}
    </span>
    <span class="pay-break-item" *ngIf="travelFee > 0">
      {{ "riepilogo.travel.label" | translate }} € {{ travelFee | number: "1.2-2" }}
    </span>
    <span class="pay-break-item" *ngIf="discountEuro > 0">
      {{ "riepilogo.discount.label" | translate }} − € {{ discountEuro | number: "1.2-2" }}
    </span>
  </div>

  <div class="pay-cols">
    <!-- Acconto -->
    <div class="pay-card" [class.paid]="deposit.paid">
      <div class="pay-card-head">
        <span class="pay-card-label">{{ "riepilogo.payments.deposit" | translate }}</span>
        <span class="pay-card-amount">€ {{ depositCost | number: "1.2-2" }}</span>
      </div>

      <label class="pay-received">
        <span>{{ "riepilogo.payments.received" | translate }}</span>
        <span class="toggle-switch">
          <input type="checkbox" [checked]="!!deposit.paid" [disabled]="savingQuick" (change)="togglePaid('deposit')" />
          <span class="toggle-slider"></span>
        </span>
      </label>
      <p class="pay-meta" *ngIf="!editMode && deposit.paid && (deposit.paid_at || deposit.method)">
        <ng-container *ngIf="deposit.paid_at">{{ "riepilogo.payments.received_on" | translate }} {{ deposit.paid_at | date: "dd/MM/yyyy" }}</ng-container>
        <ng-container *ngIf="deposit.paid_at && deposit.method"> · </ng-container>
        <ng-container *ngIf="deposit.method">{{ methodLabel(deposit.method) }}</ng-container>
      </p>
      <p class="pay-note-text" *ngIf="!editMode && deposit.note">{{ deposit.note }}</p>

      <ng-container *ngIf="editMode">
        <div class="pay-unit-toggle">
          <button
            type="button"
            class="pay-unit-btn"
            [class.active]="deposit.type !== 'percent'"
            (click)="setDepositType('fixed')"
          >€ {{ "deposit_toggle.fixed" | translate }}</button>
          <button
            type="button"
            class="pay-unit-btn"
            [class.active]="deposit.type === 'percent'"
            (click)="setDepositType('percent')"
          >% {{ "deposit_toggle.percent" | translate }}</button>
        </div>
        <div class="pay-amount-wrap">
          <span class="pay-euro">{{ deposit.type === 'percent' ? '%' : '€' }}</span>
          <input
            type="number"
            class="pay-amount-input"
            [(ngModel)]="deposit.cost"
            min="0"
            [max]="deposit.type === 'percent' ? 100 : null"
            step="0.01"
            inputmode="decimal"
          />
        </div>
        <p class="pay-deposit-resolved" *ngIf="deposit.type === 'percent'">
          = € {{ depositCost | number: "1.2-2" }}
        </p>
        <div class="pay-field" *ngIf="deposit.paid">
          <span>{{ "riepilogo.payments.paid_at" | translate }}</span>
          <input type="date" [(ngModel)]="deposit.paid_at" />
        </div>
        <div class="pay-field" *ngIf="deposit.paid">
          <span>{{ "riepilogo.payments.method" | translate }}</span>
          <select [(ngModel)]="deposit.method">
            <option value="">—</option>
            <option *ngFor="let m of methods" [value]="m">{{ methodLabel(m) }}</option>
          </select>
        </div>
        <input
          class="pay-note-input"
          [(ngModel)]="deposit.note"
          [placeholder]="'riepilogo.payments.note_placeholder' | translate"
        />
      </ng-container>
    </div>

    <!-- Saldo -->
    <div class="pay-card" [class.paid]="balance.paid" [class.overdue]="balanceOverdue">
      <div class="pay-card-head">
        <span class="pay-card-label">{{ "riepilogo.payments.balance" | translate }}</span>
        <span class="pay-card-amount">€ {{ saldo | number: "1.2-2" }}</span>
      </div>

      <label class="pay-received">
        <span>{{ "riepilogo.payments.received" | translate }}</span>
        <span class="toggle-switch">
          <input type="checkbox" [checked]="!!balance.paid" [disabled]="savingQuick" (change)="togglePaid('balance')" />
          <span class="toggle-slider"></span>
        </span>
      </label>
      <p class="pay-meta" *ngIf="!editMode && balance.paid && (balance.paid_at || balance.method)">
        <ng-container *ngIf="balance.paid_at">{{ "riepilogo.payments.received_on" | translate }} {{ balance.paid_at | date: "dd/MM/yyyy" }}</ng-container>
        <ng-container *ngIf="balance.paid_at && balance.method"> · </ng-container>
        <ng-container *ngIf="balance.method">{{ methodLabel(balance.method) }}</ng-container>
      </p>
      <p class="pay-due" [class.overdue]="balanceOverdue" *ngIf="!editMode && !balance.paid && balance.due_date">
        {{ "riepilogo.payments.due_on" | translate }} {{ balance.due_date | date: "dd/MM/yyyy" }}
      </p>
      <p class="pay-note-text" *ngIf="!editMode && balance.note">{{ balance.note }}</p>

      <ng-container *ngIf="editMode">
        <div class="pay-field" *ngIf="!balance.paid">
          <span>{{ "riepilogo.payments.due_date" | translate }}</span>
          <input type="date" [(ngModel)]="balance.due_date" />
        </div>
        <div class="pay-field" *ngIf="balance.paid">
          <span>{{ "riepilogo.payments.paid_at" | translate }}</span>
          <input type="date" [(ngModel)]="balance.paid_at" />
        </div>
        <div class="pay-field" *ngIf="balance.paid">
          <span>{{ "riepilogo.payments.method" | translate }}</span>
          <select [(ngModel)]="balance.method">
            <option value="">—</option>
            <option *ngFor="let m of methods" [value]="m">{{ methodLabel(m) }}</option>
          </select>
        </div>
        <input
          class="pay-note-input"
          [(ngModel)]="balance.note"
          [placeholder]="'riepilogo.payments.note_placeholder' | translate"
        />
      </ng-container>
    </div>
  </div>

  <div class="pay-actions" *ngIf="totalAll > 0">
    <button type="button" class="btn-outline pay-share" (click)="shareSummary()">
      <app-icon name="share" [size]="16"></app-icon>
      {{ "riepilogo.payments.share_summary" | translate }}
    </button>
  </div>
</div>
